// src/utils/auth.js
export function setToken(token) {
  localStorage.setItem('token', token)
  // 立即更新内存中的 token（关键步骤）
  if (!window.__axios_token) window.__axios_token = {}
  window.__axios_token.value = token
}

export function getToken() {
  // 优先使用内存中的 token
  return window.__axios_token?.value || localStorage.getItem('token')
}